export class CdObjectProjectTypes {
    //Объекты городского бюджета
    public static CityBudgetObjects = 3;
    //Бюджетные СКБ
    public static BudgetSKBObjects = 8;    
    //Объекты Fee development
    public static FeeDevelopmentObjects = 9;
}